import { formatDate, sanitizeUserInput } from '@/lib';

interface WishlistInfoProps {
  title: string;
  eventDate?: Date;
  iconEmoji?: string | null;
}

/**
 * Информация о вишлисте под карточкой
 * 
 * Отображает:
 * - Иконку вишлиста (если есть)
 * - Название вишлиста
 * - Дату события (если есть)
 */
export function WishlistInfo({ 
  title, 
  eventDate, 
  iconEmoji,
}: WishlistInfoProps): JSX.Element {
  // Sanitize UGC для защиты от XSS
  const safeTitle = sanitizeUserInput(title);

  return (
    <div className="mt-2 px-1">
      <div className="flex items-center gap-2">
        {/* Иконка вишлиста */}
        {iconEmoji && (
          <span className="text-base leading-none flex-shrink-0">{iconEmoji}</span>
        )}
        
        {/* Название */}
        <h3 className="font-semibold text-sm text-foreground flex-1 truncate">
          {safeTitle}
        </h3>
      </div>
      
      {/* Дата события */}
      {eventDate && (
        <p className="text-sm text-muted-foreground mt-1">
          {formatDate(eventDate)}
        </p>
      )}
    </div>
  );
}